module.exports = __webpack_public_path__ + "static/img/SQB.acbcbaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/SQB.png
// module id = 0cr3
// module chunks = 34